export default {
  props: {
    label: {
      type: String,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    noWrap: {
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    noDataText() {
      if (this.loading) {
        return 'Загружаем данные...';
      }

      return 'Данные отсутствуют';
    },
    fieldClasses() {
      return {
        'pa-0': this.dense,
        'ma-0': this.dense,
        'v-input--required': this.required,
        'v-input--nowrap': this.noWrap,
      };
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value || null);
    },
    handleBlur(value) {
      this.$emit('blur', value || null);
    },
  },
};
